export default __webpack_public_path__ + "static/media/logogram_color.e1764118.svg";